import { useState } from 'react';
import { NSelect } from '@innersource-nn/novoui-react';
import { StackType } from './StackDetails';
import useEnvironmentOptions from './hooks/useEnvironmentOptions';
import Spinner from 'components/loader/Spinner';
import { NButton, NTable } from '@innersource-nn/novoui-react';
import useStack from './hooks/useStack';
import StackContent from './StackContent';

const tableHeaders = [
    { header: 'Physical ID', key: 'PhysicalResourceId' },
    { header: 'Resource Type', key: 'ResourceType' },
];

const EnvironmentStackDetails = ({
    uri,
    environmentLabel,
}: {
    uri?: string;
    environmentLabel: string;
}) => {
    const type = StackType.environment;
    const options = useEnvironmentOptions(environmentLabel, uri);
    const [stackEnv, setStackEnv] = useState(uri);
    const { stack, loading, updateStack, updating } = useStack(type, stackEnv);

    const updateStackEnv = (e: string) => {
        setStackEnv(e);
    };

    const resources = stack.resources
        ? JSON.parse(stack.resources).resources
        : [];

    return (
        <div>
            <div className="text-true-blue">
                <h2 className="font-semibold text-xl pb-4">Stack details</h2>
                {options.length > 1 && <p className="mr-4">Selected Stack</p>}
                <div className="flex py-4">
                    <div className="flex-grow p-4">
                        {options.length > 1 && (
                            <div className="flex items-center">
                                <div className="flex-grow">
                                    <NSelect
                                        variant="outline"
                                        options={options}
                                        value={stackEnv}
                                        defaultValue={stackEnv}
                                        onChange={(e) => {
                                            updateStackEnv(e.target.value);
                                        }}
                                        modelValue={stackEnv}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                    <div>
                        <div className="flex items-center p-4">
                            <NButton
                                variant="outline"
                                onClick={updateStack}
                                leftIcon="refresh"
                                square
                                isLoading={updating}
                                size="medium"
                            >
                                Update Stack
                            </NButton>
                        </div>
                    </div>
                </div>
                {loading ? (
                    <Spinner />
                ) : (
                    <StackContent
                        stack={stack}
                        resources={resources}
                        tableHeaders={tableHeaders}
                    />
                )}
            </div>
        </div>
    );
};

export default EnvironmentStackDetails;
